import { useContext, useEffect } from 'react';
import SubscriptionContext from 'src/context/subscription';
import AccountsService from 'src/services/AccountsService';
import { useQuery } from 'react-query';
import { storeSubscription } from 'src/storage/subscription';

const FlipperCheck = (subId) => {
  const { subscriptionContext, setSubscriptionContext } =
    useContext(SubscriptionContext);
  const resolvedSubId = subId || subscriptionContext.subId;

  const flipperCheck = useQuery(
    ['flipper', resolvedSubId],
    async () => {
      const data = await AccountsService.checkFlipper(resolvedSubId);
      return data;
    },
    {
      enabled: Boolean(resolvedSubId),
    }
  );

  useEffect(() => {
    if (!flipperCheck.data) {
      return;
    }

    setSubscriptionContext((previousContext) => ({
      ...previousContext,
      flipperContext: {
        flipper: flipperCheck.data?.data?.flipper ?? false,
        subscription_id: flipperCheck.data?.data?.subscription_id ?? '',
        org_id: flipperCheck.data?.data?.org_id ?? '',
        site_id: flipperCheck.data?.data?.site_id ?? '',
        job_cost_v4: flipperCheck.data?.data?.job_cost_v4 ?? false,
        release_resupply_model_v3:
          flipperCheck.data?.data?.release_resupply_model_v3 ?? false,
      },
    }));

    storeSubscription({
      subId: resolvedSubId,
      token: subscriptionContext.token,
    });
  }, [
    flipperCheck.data,
    resolvedSubId,
    subscriptionContext.token,
    setSubscriptionContext,
  ]);
};

export default FlipperCheck;
